import VariablesActions from '../actions/VariablesCRUDActions';
import Actions from '../actions/actions';
import { setBusy, setUnBusy, retrievedAll } from './common/commonReducers';

const initialState = {
  busy: false,
  entities: [],
};

export default function forms(state = initialState, action) {
  switch (action.type) {
    case VariablesActions.busyAction: return setBusy(state);
    case VariablesActions.retrievedAllAction: return retrievedAll(state, action);
    case Actions.RESET: return initialState;
    case Actions.UNBUSY: return setUnBusy(state);
    default: return state;
  }
}
